export const OPEN_CREATE_DOMAIN_MODAL = 'OPEN_CREATE_DOMAIN_MODAL';

export const DOMAIN_STATUS = {
    PARTIAL: 3,
    RUNNING: 4,
};
